import { render, staticRenderFns } from "./sub-certification.vue?vue&type=template&id=1def1efa&scoped=true&"
import script from "./sub-certification.vue?vue&type=script&lang=js&"
export * from "./sub-certification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1def1efa",
  null
  
)

export default component.exports